import type { RentSituation } from '@einwert/valuation-api-client'
import { Stack } from '@mui/material'
import { ReasonIcon, tokens, Typography } from 'ComponentLibrary'
import { RatingChip } from 'ClientPortal/src/pages/Assets/AssetDetails/Valuation/ValuationMarketData/Comparables/Preview/RatingChip'

export type RatingRow = { label: string; type: 'location' | 'asset' | 'rent'; rating?: number | RentSituation }

type RatingRowsProps = {
    rows: RatingRow[]
}

export const RatingRows = ({ rows }: RatingRowsProps) => {
    return (
        <Stack direction="column" gap={tokens.SizingSpacing075}>
            {rows.map(({ label, type, rating }) => (
                <Stack direction="row" key={label} justifyContent="space-between" spacing={tokens.SizingSpacing100}>
                    <Stack direction="row" gap={tokens.SizingSpacing100} alignItems="center">
                        <ReasonIcon type={type} size={tokens.SizingIconS} color={tokens.ColorIconSubtle} />
                        <Typography variant="bodyTextMedium" color={tokens.ColorTextSubtle}>
                            {label}
                        </Typography>
                    </Stack>
                    <RatingChip rating={rating} />
                </Stack>
            ))}
        </Stack>
    )
}
